export function HeaderLarge({ header }: { header: string }) {
  return (
    <h1 className="font-medium text-3xl text-primary-ferrari ">{header}</h1>
  );
}
